import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import MarketplacePage from "./pages/MarketplacePage";
import RegisterPage from "./pages/RegisterPage";
import OptionHolders from "./pages/OptionHolders";
import UserSettings from "./pages/UserSettings";
import Landing from "./pages/landing";
import Notice from "./pages/notice";
import Withdraw from "./pages/Withdraw";
import LevelUp from "./pages/levelup";
import Referal from "./pages/referal";
import BuyAds from "./pages/buyads";
import Leaderboard from "./pages/Leaderboard";
import Autosurf from "./pages/autosurf";
import Draw from "./pages/draw";
import Howitworks from "./pages/howitworks";
import Bonus from "./pages/Bonus";
import AutosurfValidation from "./pages/AutosurfValidation";
import Conditions from "./pages/Terms";
import PTP from './pages/PTP';
import Ptppage from './pages/ptppage';

import Blog from "./pages/blog";
import BlogOwingOptions from './pages/blog/BlogOwingOptions';
import BlogWelcome from './pages/blog/BlogWelcome';
import BlogAutoSurf from './pages/blog/BlogAutoSurf';
import BlogNewCrypto from './pages/blog/BlogNewCrypto';

import jwtDecode from 'jwt-decode';
import CookieConsent from "./components/CookieConsent";
import axios from './axiosInstance';



function App() {
  const [loggedIn, setLoggedIn] = useState(false); // Défaut : false
  const [loading, setLoading] = useState(true);
  
  const checkAuth = async () => {
    try {
      const response = await axios.get('/api/check-auth', { withCredentials: true });
	  
      if (response.data.message === "Authentifié") {
	
        setLoggedIn(true);
      } else {
		  
        setLoggedIn(false);
      }
    } catch (error) {
	  console.log("ERREUR : ",error);
      setLoggedIn(false);
    } finally {
    setLoading(false); // Fin du chargement, qu'il soit réussi ou non
  }
		
  };

  useEffect(() => {
    checkAuth(); // Vérifie une première fois au chargement

    const interval = setInterval(() => {
      checkAuth(); // Revérifie toutes les minutes
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = () => {
    setLoggedIn(true);
  };

  const handleLogout = () => {
    axios.get('/api/logout', { withCredentials: true })
      .then(() => setLoggedIn(false))
      .catch(() => setLoggedIn(false));
  };

  return (
 
    <Router>
      <CookieConsent />
    
      <Routes>
        <Route path="/" element={ <Navigate to="/index" />} />
        <Route path="/index" element={<Landing />} />
        <Route path="/notice" element={<Notice />} />
		    <Route path="/terms" element={<Conditions />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/welcome" element={<BlogWelcome />} />
        <Route path="/blog/owingoptions" element={<BlogOwingOptions />} />
        <Route path="/blog/autosurf" element={<BlogAutoSurf />} />
        <Route path="/ptp/" element={<PTP />} />
        
        <Route path="/blog/newcrypto" element={<BlogNewCrypto />} />
        <Route path="/login" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <Navigate to="/dashboard" /> : <LoginPage onLogin={handleLogin} />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <DashboardPage onLogout={handleLogout} /> : <Navigate to="/index" />} />
      
      <Route path="/marketplace" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>      
    </div> : loggedIn  ? <MarketplacePage onLogout={handleLogout}/> : <Navigate to="/index" />} />
    
    <Route path="/draw" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">      
    <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>      
    </div> : loggedIn  ? <Draw onLogout={handleLogout}/> : <Navigate to="/index" />} />

    <Route path="/leaderboard" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">      
    <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>      
    </div> : loggedIn  ? <Leaderboard onLogout={handleLogout}/> : <Navigate to="/index" />} />
    
    <Route path="/ptppage" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">      
    <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>      
    </div> : loggedIn  ? <Ptppage onLogout={handleLogout}/> : <Navigate to="/index" />} />

    <Route path="/bonus" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>      
    </div> : loggedIn  ? <Bonus onLogout={handleLogout}/> : <Navigate to="/index" />} />

    <Route path="/howitworks" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>      
    </div> : loggedIn  ? <Howitworks onLogout={handleLogout}/> : <Navigate to="/index" />} />


        <Route path="/optionholder" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <OptionHolders onLogout={handleLogout}/> : <Navigate to="/index" />} />
        <Route path="/withdraw" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <Withdraw onLogout={handleLogout}/> : <Navigate to="/index" />} />
        <Route path="/usersettings" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <UserSettings onLogout={handleLogout}/> : <Navigate to="/index" />} />
		<Route path="/levelup" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <LevelUp onLogout={handleLogout}/> : <Navigate to="/index" />} />
		<Route path="/referral" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <Referal onLogout={handleLogout}/> : <Navigate to="/index" />} />
		<Route path="/buyads" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <BuyAds onLogout={handleLogout}/> : <Navigate to="/index" />} />AutosurfValidation
		<Route path="/autosurf" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <Autosurf onLogout={handleLogout}/> : <Navigate to="/index" />} />	
		<Route path="/autosurfvalidation" element={loading ? <div className="fixed inset-0 bg-gray-950 text-white flex flex-col items-center justify-center z-50">
      
      <div className="loader-circle mb-2"></div>
      <p className="text-sm text-gray-400">Loading...</p>
    </div> : loggedIn  ? <AutosurfValidation onLogout={handleLogout}/> : <Navigate to="/index" />} />		
        <Route path="*" element={<Navigate to={loggedIn ? "/dashboard" : "/index"} />} />
      </Routes>
    </Router>
  );
}


export default App;
